import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CambioPiano } from '../../../models/fisso';

@Component({
  selector: 'alg-change-plan-info-subscription',
  templateUrl: './alg-change-plan-info-subscription.component.html',
  styleUrls: ['./alg-change-plan-info-subscription.component.scss'],
})
export class AlgChangePlanInfoSubscriptionComponent implements OnInit {
  @Output() checkboxOutputConsents = new EventEmitter<boolean>();
  @Input() changePlan: CambioPiano;
  @Input() isProductGasVulnerable: boolean;
  @Input() isGenericVulnerable: boolean;
  @Input() invalid104Condition: boolean;

  constructor() {}

  ngOnInit() {}

  public getValid104Checkbox(value: boolean) {
    this.checkboxOutputConsents.emit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-change-plan/alg-change-plan-info-subscription/alg-change-plan-info-subscription.component.ts